module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet box blue-hoki margin-top-20"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.updateFolder()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearError('errorMessage')
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folder.name),
      expression: "folder.name"
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.folder.name
    },
    attrs: {
      "type": "text",
      "id": "form_control_name"
    },
    domProps: {
      "value": (_vm.folder.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.folder, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_name"
    }
  }, [_vm._v("Name")])])])]), _vm._v(" "), _vm._m(1, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v("\n\t\t\tCreate Resource Folder\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    staticClass: "expand"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('button', {
    staticClass: "btn blue pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559528d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Gallery/EditFolder.vue
// module id = 725
// module chunks = 0